"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeInvitations_en_us = void 0;
function backofficeInvitations_en_us() {
    return {
        "backoffice.invitations.invitedialog.title": "Send out an invitation",
        "backoffice.invitations.invitedialog.company": "Company Roles",
        "backoffice.invitations.invitedialog.projects": "Project Roles",
        "backoffice.invitations.invitedialog.email": "E-Mail",
        "backoffice.invitations.invitedialog.companypermissions": "Permissions",
        "backoffice.invitations.invitedialog.projectpermissions": "Permissions",
        "backoffice.invitations.invitedialog.roles": "Roles",
        "backoffice.invitations.invitedialog.invite": "Invite",
        "backoffice.invitations.invitedialog.noprojectsfound": "There are no projects to add users to!",
        "backoffice.invitations.invitedialog.addprojectpermission": "Add Project Permissions",
        "backoffice.invitations.invitedialog.chooseproject": "Choose Project",
        "backoffice.invitations.invitedialog.noprojectroles": "No roles exist for this project. You need to create at least one project role in order to send an invite",
        "backoffice.invitations.invitedialog.nocompanyroles": "No roles exist for this company. You need to create at least one company role in order to send an invite",
        "backoffice.invitations.invitedialog.createrole": "Create Role",
        "backoffice.invitations.messages.currentlyaccepting": "Accepting invitation...",
        "backoffice.invitations.messages.successtitle": "Invitation accepted",
        "backoffice.invitations.messages.successmessage": "The invitation was successfully accepted. Where do you want to go next?",
        "backoffice.invitations.messages.gotoproject": "Onwards to the project",
        "backoffice.invitations.errors.400": "This invitation link is invalid!",
        "backoffice.invitations.errors.404": "This invitation link is invalid!",
        "backoffice.invitations.errors.alreadyused": "This invitation link has already been used!"
    };
}
exports.backofficeInvitations_en_us = backofficeInvitations_en_us;
